import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
@Component({
    selector: 'sale-pill',
    templateUrl: 'sale-pill.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule]
})
export class SalePillComponent {
    @Input()
    copy?: string;
    @Input()
    textColor?: string;
    @Input()
    bgColor?: string;
    @Input()
    small = false;
}
